import React from 'react';
// import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { newFetch as fetch } from '~helpers/graphql';
import * as queries from '~settings/queries';
import LongtailPaymentList from '~pages/dashboard/payment/long-tail/list';
import LongtailPaymentSetup from '~pages/dashboard/payment/long-tail/setup';
import { withTranslation } from 'react-i18next';

@withTranslation(['cms', 'landlord'])
export default class PaymentDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      landlord: this.props?.landlord || null,
    };
  }
  getLandlordDetails = slug => {
    fetch({
      query: queries.getLandlord(slug),
    }).then(res => {
      if (res?.landlord) {
        this.setState({ landlord: res?.landlord });
      }
    });
  };

  componentDidMount() {
    if (!this.props?.landlord && this.props.match?.params?.landlordSlug) {
      this.getLandlordDetails(this.props.match?.params?.landlordSlug);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps?.landlord && !this.state.landlord) {
      this.setState({ landlord: nextProps?.landlord });
    }
  }
  render() {
    return (
      <div className="payment container">
        <If condition={this.state.landlord}>
          <div className="payment__container payment__container--long-tail loading-wrapper">
            <Switch>
              {/* Longtail */}

              <Route
                path="/landlord/:landlordSlug/payment/setup/:step?"
                render={({ ...restProps }) => (
                  <LongtailPaymentSetup
                    landlord={this.state.landlord}
                    t={this.props.t}
                    {...restProps}
                  />
                )}
              />

              <Route
                path="/landlord/:landlordSlug/payment/list"
                render={() => (
                  <LongtailPaymentList
                    landlordId={this.state.landlord?.id}
                    landlord={this.state.landlord}
                  />
                )}
              />
            </Switch>
          </div>
        </If>
      </div>
    );
  }
}
